<div class="mb-3">
  <div class="d-flex justify-content-between">
    <label class="input__label mb-0">{{ label }}</label>
    <!-- <small class="text-muted required-label">verplicht</small> -->
  </div>
  <ng-content></ng-content>
  @if (explanation) {
    <small class="form-text text-muted">
      {{ explanation }}
    </small>
  }
  @if (control != null && !hideValidationMessage) {
    <app-validation-message [control]="control"></app-validation-message>
  }
</div>
